export default __webpack_public_path__ + "static/media/marriage.5d390d0347035ec620f82565ef8e3719.png";